module.exports = __webpack_public_path__ + "app/components/accordion-1-wh7TNX.html";